/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreCommonExcelExportExcelRequest,
  FacilityFlowCoreCommonExcelImportResultDto,
  FacilityFlowCoreModulesPlanningDtosTasksCreateTaskRequest,
  FacilityFlowCoreModulesPlanningDtosTasksDeleteTaskResult,
  FacilityFlowCoreModulesPlanningDtosTasksTaskDto,
  FacilityFlowCoreModulesPlanningDtosTasksTaskListDto,
  FacilityFlowCoreModulesPlanningDtosTasksUpdateTaskRequest,
  GetApiV1TasksParams,
  PostApiV1TasksImportExcelBody,
  PostApiV1TasksImportExcelParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTasks = () => {
/**
 * @summary Get all task definitions with optional filters
 */
const getApiV1Tasks = (
    params?: GetApiV1TasksParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskListDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskListDto[]>(
      {url: `/api/v1/tasks`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new task definition
 */
const postApiV1Tasks = (
    facilityFlowCoreModulesPlanningDtosTasksCreateTaskRequest: FacilityFlowCoreModulesPlanningDtosTasksCreateTaskRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskDto>(
      {url: `/api/v1/tasks`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosTasksCreateTaskRequest
    },
      options);
    }
  /**
 * @summary Get task definition by ID
 */
const getApiV1TasksId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskDto>(
      {url: `/api/v1/tasks/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing task definition
 */
const putApiV1TasksId = (
    id: string,
    facilityFlowCoreModulesPlanningDtosTasksUpdateTaskRequest: FacilityFlowCoreModulesPlanningDtosTasksUpdateTaskRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosTasksTaskDto>(
      {url: `/api/v1/tasks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosTasksUpdateTaskRequest
    },
      options);
    }
  /**
 * @summary Deletes the task and removes it from the planning from today on. A task with history
is deactivated instead (`deactivated: true`).
 */
const deleteApiV1TasksId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosTasksDeleteTaskResult>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosTasksDeleteTaskResult>(
      {url: `/api/v1/tasks/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Download all tasks as an Excel workbook. Two sheets: the activities and their
schedule rules. Object, service and task appear as dropdowns.
 */
const postApiV1TasksExportExcel = (
    facilityFlowCoreCommonExcelExportExcelRequest: FacilityFlowCoreCommonExcelExportExcelRequest,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/tasks/export/excel`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreCommonExcelExportExcelRequest,
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Import an edited task workbook. With `dryRun=true` (the default) the
response is a preview and nothing is written.
 */
const postApiV1TasksImportExcel = (
    postApiV1TasksImportExcelBody: PostApiV1TasksImportExcelBody,
    params?: PostApiV1TasksImportExcelParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreCommonExcelImportResultDto>>,) => {const formData = new FormData();
if(postApiV1TasksImportExcelBody.file !== undefined) {
 formData.append(`file`, postApiV1TasksImportExcelBody.file)
 }
if(postApiV1TasksImportExcelBody.excludeRows !== undefined) {
 postApiV1TasksImportExcelBody.excludeRows.forEach(value => formData.append(`excludeRows`, value));
 }

      return customInstance<FacilityFlowCoreCommonExcelImportResultDto>(
      {url: `/api/v1/tasks/import/excel`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params
    },
      options);
    }
  return {getApiV1Tasks,postApiV1Tasks,getApiV1TasksId,putApiV1TasksId,deleteApiV1TasksId,postApiV1TasksExportExcel,postApiV1TasksImportExcel}};
export type GetApiV1TasksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTasks>['getApiV1Tasks']>>>
export type PostApiV1TasksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTasks>['postApiV1Tasks']>>>
export type GetApiV1TasksIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTasks>['getApiV1TasksId']>>>
export type PutApiV1TasksIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTasks>['putApiV1TasksId']>>>
export type DeleteApiV1TasksIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTasks>['deleteApiV1TasksId']>>>
export type PostApiV1TasksExportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTasks>['postApiV1TasksExportExcel']>>>
export type PostApiV1TasksImportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTasks>['postApiV1TasksImportExcel']>>>
